import { render, staticRenderFns } from "./DefStrategy.vue?vue&type=template&id=53b6ee81&"
import script from "./DefStrategy.vue?vue&type=script&lang=ts&"
export * from "./DefStrategy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports